import React from 'react';
import { Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import NoAudienceDataAlertHolder from './NoAudienceDataAlertStyle';
import Colors from '../../../themes/Colors';

const NoAudienceDataAlert = () => {
  const { t } = useTranslation();

  return (
    <NoAudienceDataAlertHolder>
      <div className="no-audience-data-alert">
        <div className="no-audience-data-alert__container">
          <div className="no-audience-data-alert__icon-container">
            <Icon type="warning" style={{ fontSize: '35px', color: Colors.atention }} />
          </div>
          <div className="no-audience-data-alert__message">
            {t('There is no audience data for this screen')}
          </div>
        </div>
      </div>
    </NoAudienceDataAlertHolder>
  );
};

export default NoAudienceDataAlert;